// Copyright (c) Hamilton Manufacturing Corp.
import Carousel from 'nuka-carousel/lib/carousel';
import React from 'react';
import styled from 'styled-components';
import { generateId, mobileView } from './api/utility';
import { useGlobalState } from './globalState/GlobalStateProvider';

const Slide = styled.div`
    width: 100%;
    height: ${({ mobile }) => mobile ? `${window.innerHeight - 60}px` : '75vh'};

    display: flex;
    align-items: center;
    justify-content: center;
`;

const HamCarousel = ({ children, ...props }) => {
    const {
        state: {
            // mobileView
        },
    } = useGlobalState();

    return (
        <Carousel
            autoplay={true}
            wrapAround={true}
            withoutControls={true}
            autoplayInterval={4000}
            animation={'zoom'}
            pauseOnHover={true}
            swiping={!mobileView}
            {...props}
        >
            {children.map(e => <Slide mobile={mobileView} key={generateId()}>{e}</Slide>)}
        </Carousel>
    );
}

export default HamCarousel;